import { render } from "./pos-header.vue?vue&type=template&id=3ba32c7a&scoped=true"
import script from "./pos-header.vue?vue&type=script&lang=js"
export * from "./pos-header.vue?vue&type=script&lang=js"

import "./pos-header.vue?vue&type=style&index=0&id=3ba32c7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ba32c7a"]])

export default __exports__